module.exports = __webpack_public_path__ + "img/occhiuzzi.fc7ce211.png";